var map = {
	"./views/course/list.vue": [
		"CNgo",
		5
	],
	"./views/desk/index.vue": [
		"AD5D",
		2
	],
	"./views/limits/list.vue": [
		"LJyh",
		1
	],
	"./views/order/list.vue": [
		"Eh9J",
		4
	],
	"./views/user/list.vue": [
		"BepB",
		3
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "HUGQ";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src lazy ^\.\/views.*\.vue$
// module id = HUGQ
// module chunks = 7